import FetchWrapper from "./FetchWrapper";
import { SERVER } from '../constants/ServiceConstants'

const getWishlistItemDetails = (wishlistId, itemId) => {
  return FetchWrapper(`/wishlists/${wishlistId}/items/${itemId}`);
};

export { getWishlistItemDetails }